const hasSymbol = typeof Symbol === 'function' && Symbol.for;
export default hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/ThemeProvider/nested.js
// module id = 848
// module chunks = 25